var _excluded = ["color", "hoverColor", "isThemeDark", "style", "children", "size", "viewBox", "htmlAttributes", "title", "desc", "suppressTitle"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

import * as React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import generateUUID from "../../utils/generateUUID";
import { StyleSheet, css, color, transition, iconSize } from "../../styles/theme";

// Dynamic styles
function getStyles(_ref) {
  var propColor = _ref.propColor,
    hoverColor = _ref.hoverColor,
    size = _ref.size,
    hovered = _ref.hovered;
  return {
    SvgIcon: {
      fill: hovered && hoverColor ? hoverColor : propColor,
      height: size,
      width: size
    }
  };
}
var styles = StyleSheet.create({
  SvgIcon: {
    display: 'inline-block',
    verticalAlign: 'middle',
    color: color.icon,
    transition: transition.easeOut(),
    userSelect: 'none'
  }
});
var SvgIcon = /*#__PURE__*/function (_React$Component) {
  function SvgIcon(props) {
    var _this;
    _classCallCheck(this, SvgIcon);
    _this = _callSuper(this, SvgIcon, [props]);
    _defineProperty(_this, "defaultProps", void 0);
    _defineProperty(_this, "handleMouseLeave", function (e) {
      if (!_this.props.disableMouseEvent) {
        _this.setState(function () {
          return {
            hovered: false
          };
        });
        if (_this.props.onMouseLeave) {
          _this.props.onMouseLeave(e);
        }
      }
    });
    _defineProperty(_this, "handleMouseEnter", function (e) {
      if (!_this.props.disableMouseEvent) {
        _this.setState(function () {
          return {
            hovered: true
          };
        });
        if (_this.props.onMouseEnter) {
          _this.props.onMouseEnter(e);
        }
      }
    });
    _this.state = {
      hovered: !!props.hovered,
      uuid: 'default'
    };
    return _this;
  }
  _inherits(SvgIcon, _React$Component);
  return _createClass(SvgIcon, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('hovered' in nextProps && !!nextProps.hovered !== !!this.state.hovered) {
        this.setState(function () {
          return {
            hovered: !!nextProps.hovered
          };
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState(function () {
        return {
          uuid: generateUUID()
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        colorAlt = _this$props.color,
        hoverColor = _this$props.hoverColor,
        isThemeDark = _this$props.isThemeDark,
        style = _this$props.style,
        children = _this$props.children,
        size = _this$props.size,
        viewBox = _this$props.viewBox,
        htmlAttributes = _this$props.htmlAttributes,
        title = _this$props.title,
        desc = _this$props.desc,
        suppressTitle = _this$props.suppressTitle,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var _this$state = this.state,
        hovered = _this$state.hovered,
        uuid = _this$state.uuid;
      var iconColor = colorAlt || (isThemeDark ? color.iconThemeDark : color.icon);
      var dynamicStyles = getStyles({
        propColor: iconColor,
        hoverColor: hoverColor || iconColor,
        size: size || iconSize.sm,
        hovered: hovered
      });
      var mergedStyles = _objectSpread(_objectSpread({}, dynamicStyles.SvgIcon), style);
      var additionalProps = omit(rest, ['disableMouseEvent', 'hovered']);
      var a11yTitleId = title ? "".concat(title.replace(/\s/g, '')).concat(uuid) : uuid;
      var a11yDescId = "".concat(a11yTitleId, "Desc");

      // using labelling strategy from https://developer.paciellogroup.com/blog/2013/12/using-aria-enhance-svg-accessibility/
      var labelledBy = "".concat(a11yTitleId, " ").concat(a11yDescId);
      return /*#__PURE__*/React.createElement("svg", _extends({}, additionalProps, htmlAttributes, css(styles.SvgIcon), suppressTitle ? {
        'aria-hidden': true,
        'focusable': 'false'
      } : {}, {
        style: mergedStyles,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        viewBox: viewBox,
        role: "img",
        "aria-labelledby": labelledBy,
        xmlns: "http://www.w3.org/2000/svg"
      }), !suppressTitle && title && /*#__PURE__*/React.createElement("title", {
        id: a11yTitleId
      }, title), desc && /*#__PURE__*/React.createElement("desc", {
        id: a11yDescId
      }, desc), React.Children.map(children, function (child) {
        return child && /*#__PURE__*/React.cloneElement(child, {
          role: 'presentation'
        }) || null;
      }));
    }
  }]);
}(React.Component);
_defineProperty(SvgIcon, "propTypes", {
  // Override the inline-styles of the root element
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  // Attributes overwrite.
  htmlAttributes: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  // Elements passed into the SVG Icon.
  children: PropTypes.node,
  // Fill color of the svg, default to color.icon.
  color: PropTypes.string,
  isThemeDark: PropTypes.bool,
  // Width and height of the svg, should be equal, so only use size.
  size: PropTypes.number,
  // Accessible title for the icon is shown by browsers as a hover tooltip, defaults are defined in each icon
  title: PropTypes.string,
  // Longer Accessible description for the icon, assistive technologies replace the image with the desc
  desc: PropTypes.string,
  // Allows supressing the title for purely presentational icons
  suppressTitle: PropTypes.bool,
  // Default to color.darkPrimary
  hoverColor: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  // Allows you to redefine what the coordinates
  viewBox: PropTypes.string,
  hovered: PropTypes.bool,
  // Sometimes may need to disable mouse event so hovered state can
  // be passed in, e.g. SvgButton
  disableMouseEvent: PropTypes.bool
});
_defineProperty(SvgIcon, "defaultProps", {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  suppressTitle: false,
  color: color.icon,
  isThemeDark: false,
  viewBox: '0 0 24 24',
  size: iconSize.sm,
  // 24
  style: {},
  htmlAttributes: {},
  disableMouseEvent: false
});
export { SvgIcon as default };